import axios from 'axios'

/*
 * How long adding a booking takes, end to end (#671 sidebar).
 *
 * Measured in the browser because the question is what the person waits for: validation, the save
 * request, and the calendar refresh that follows it. Server handler time is one stage among seven,
 * so a server-side metric would have pointed at the wrong thing.
 *
 * Cheap by construction: it keeps two numbers and posts them once. A sample is fire-and-forget, so
 * a failure to record can never break the thing being measured.
 */
const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now())

const start = (action, view) => {
  const startedAt = now()
  const steps = []

  return {
    mark(name) {
      const at = now()
      steps.push({ name, ms: Math.round(at - startedAt) - totalSoFar(steps) })
    },
    // `ok` exists so a failed save is not averaged in with a successful one: a fast failure is not
    // a fast booking.
    finish(ok = true) {
      const totalMs = Math.round(now() - startedAt)
      if (!ok || action === 'update') return totalMs

      try {
        axios.post('/api/log/booking', { action, view, totalMs, steps }).catch(() => {})
      } catch (err) {
        // Never let measurement break the feature it measures.
      }

      return totalMs
    },
  }
}

// Each mark is stored as the time since the previous one, which is what makes the stages add up.
const totalSoFar = steps => steps.reduce((sum, step) => sum + step.ms, 0)

export { start }
